exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".icon img[data-v-1a93f1ac] {\n  width: 16px;\n  height: 16px;\n  display: block;\n}\n", ""]);

// exports
